import styled from 'styled-components';

export const LoginIcon = styled.div`
  && {
    background: ${(props) => props.theme.colors.lightsolitude};
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.colors.malibu};
    line-height: 27px;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0.75rem;
    cursor: default;
  }
`;

export const LoginIconWrapper = styled.div`
  position: relative;
`;

export const MessagesBadge = styled.div`
  position: absolute;
  top: -0.5em;
  right: -0.5em;
  border-radius: 1em;
  width: 1.25em;
  height: 1.25em;
  background-color: ${(props) => props.theme.colors.radicalRed};

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const UnreadMessages = styled.span`
  color: ${(props) => props.theme.colors.white};
  line-height: 0.75em;
  font-size: 0.75em;
  font-weight: 400;
`;
